import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { AppCustomConfigService } from '../../../../core/services/app-custom-config.service';
import { LinkConfigEntry } from '../../../../core/base-api';

@Injectable()
export class LinkResolver {
  constructor(private linkService: AppCustomConfigService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<LinkConfigEntry> {
    const id = route.paramMap.get('id');
    if (id) {
      return this.linkService.getLinkConfig(id);
    }
    return EMPTY;
  }
}
